
import Vue from 'vue';
import { Color } from '@/model';

function colorToHex(c: Color): string {
  const toHex = (n: number) => n.toString(16).padStart(2, '0').toUpperCase();
  return `#${toHex(c.r)}${toHex(c.g)}${toHex(c.b)}`;
}

function hexToColor(hex: string): Color | null {
  const clean = hex.startsWith('#') ? hex.slice(1) : hex;
  if (!/^[0-9A-Fa-f]{6}$/.test(clean)) return null;
  return {
    r: parseInt(clean.slice(0, 2), 16),
    g: parseInt(clean.slice(2, 4), 16),
    b: parseInt(clean.slice(4, 6), 16),
  };
}

export default Vue.extend({
  name: 'ColorPicker',

  props: {
    value: { type: Object as () => Color | undefined, required: false },
    expand: { type: Boolean, default: false },
  },

  data() {
    return {
      collapsed: !this.expand,
      selected: this.value || { r: 50, g: 50, b: 50 },
      hexError: false,
      swatches: [
        ['#00F5D4', '#00BBF9', '#FEE440', '#F15BB5', '#9B5DE5'],
      ],
    };
  },

  computed: {
    dotStyle() {
      const c = this.value || { r: 230, g: 230, b: 230 };
      return {
        background: `rgb(${c.r},${c.g},${c.b})`,
      };
    },
    hexValue(): string {
      return colorToHex(this.selected);
    },
  },

  watch: {
    value(v: Color | undefined) {
      if (v) this.selected = v;
    },
  },

  methods: {
    onSelected(color: Color) {
      this.selected = color;
      this.hexError = false;
      this.$emit('input', color);
    },
    onHexInput(hex: string) {
      const color = hexToColor(hex);
      if (color) {
        this.hexError = false;
        this.selected = { ...this.selected, ...color };
        this.$emit('input', this.selected);
      } else {
        this.hexError = true;
      }
    },
  },

});
